export const eventSources = {
  landingPage: 'landing-page',
  queryParam: 'query-param',
  causeSelection: 'cause-selection',
};

export const OH_FOUNDATION_TAX_ID = '271530711';
